import React, {useState} from 'react';
import {Player} from './types';

export interface VoteOption {
    id: string;
    text?: string;
    imageSrc?: string;
    authorId: string | null;
}

export interface VoteRecord {
    playerId: string;
    optionId: string;
}

interface Props {
    players: Player[];
    options: VoteOption[];
    voteQuestion: string;
    prompt?: React.ReactNode;
    onDone: (votes: VoteRecord[]) => void;
}

/** Passes the phone player-by-player, collecting one private vote each - own submissions are hidden from the voter. */
const VoteAmongOptions: React.FC<Props> = ({players, options, voteQuestion, prompt, onDone}) => {
    const [index, setIndex] = useState(0);
    const [ready, setReady] = useState(false);
    const [votes, setVotes] = useState<VoteRecord[]>([]);

    const player = players[index];
    const isLast = index + 1 >= players.length;
    const votable = options.filter(o => o.authorId !== player.id);

    const vote = (optionId: string) => {
        const next = [...votes, {playerId: player.id, optionId}];
        setVotes(next);
        if (isLast) {
            onDone(next);
        } else {
            setIndex(index + 1);
            setReady(false);
        }
    };

    if (!ready) {
        return (
            <div className="GmPassCard">
                <p className="GmPassCard-hint">Передайте телефон игроку</p>
                <h2 className="GmPassCard-name">{player.name}</h2>
                <button className="GmBtn GmBtn--primary GmBtn--big" onClick={() => setReady(true)}>
                    Я — {player.name}, голосовать
                </button>
                <p className="GmPassCard-progress">{index + 1} / {players.length}</p>
            </div>
        );
    }

    return (
        <div className="GmCard">
            <p className="GmHint GmHint--warn">⚠ Не показывайте экран остальным!</p>
            {prompt && <div style={{marginBottom: 12}}>{prompt}</div>}
            <p className="GmHint" style={{marginBottom: 8}}>{voteQuestion}</p>
            <div className="GmVoteList">
                {votable.map(o => (
                    <button className="GmVoteOption" key={o.id} onClick={() => vote(o.id)}>
                        {o.imageSrc ? <img className="GmVoteOption-image" src={o.imageSrc} alt=""/> : null}
                        {o.text ? <span>{o.text}</span> : null}
                    </button>
                ))}
            </div>
        </div>
    );
};

export default VoteAmongOptions;
